import { render, staticRenderFns } from "./BelongedRedeemCodeList.vue?vue&type=template&id=46faba66&"
import script from "./BelongedRedeemCodeList.vue?vue&type=script&lang=js&"
export * from "./BelongedRedeemCodeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports